import angular from 'angular';
import ngShowdown from 'ng-showdown';
import ngSanitize from 'angular-sanitize';
import template from './template.jade';
import controller from './controller';
import apiFactory from './api-factory';
import auctionApi from './auctionApi';
import demandApi from './demandApi';
import { priceFilter } from './utils/priceFilter';
import checkPublishDirective from './check-publish/check-publish.directive';
import checkServiceDirective from './check-service/check-service.directive';
import insufficientFundsDirective from './insufficient-funds/insufficient-funds.directive';
import auctionTopPopupDirective from './auction-top-popup/auction-top-popup.directive';
import uiCianIcon from './icon/icon.module';

import './styles.styl';

import uiCianSwitcher from '@cian/ui/app/components/switcher/index';
import uiCianPreloader from '@cian/ui/app/components/preloader/index';
import uiCianDropdown from '@cian/ui/app/components/dropdown/index';
import uiCianRadioWrapper from '@cian/ui/app/components/radio-wrapper/index';
import uiCianCheckboxWrapper from '@cian/ui/app/components/checkbox-wrapper/index';
import { HighDemand } from './HighDemand/HighDemand.directive';
import { AreaParts } from './AreaParts/AreaParts.directive';
import { SubscriptionOption } from './components/SubscriptionOption';

export default angular
  .module('cian.placing-terms', [
    ngSanitize,
    uiCianSwitcher,
    uiCianRadioWrapper,
    uiCianPreloader,
    uiCianDropdown,
    uiCianCheckboxWrapper,
    uiCianIcon,
    ngShowdown.name,
  ])
  .factory('placingTermsApi', apiFactory)
  .factory('auctionApi', auctionApi)
  .factory('demandApi', demandApi)
  .filter('price', priceFilter)
  .constant('placingTermsConfig', {
    imagesPath: '/images/',
    checkPublishApi: '/cian-api/site/v1/check-publish/',
    checkServiceApi: '/cian-api/site/v1/check-service/',
  })
  .directive('cianUiCheckPublish', checkPublishDirective)
  .directive('cianUiCheckService', checkServiceDirective)
  .directive('cianPublishTermsInsufficientFunds', insufficientFundsDirective)
  .directive('cianAuctionTopPopup', auctionTopPopupDirective)
  .directive('cianHighDemand', HighDemand)
  .directive('cianAreaParts', AreaParts)
  .directive('cianSubscriptionOption', SubscriptionOption)
  .directive('cianUiPlacingTerms', () => ({
    template,
    scope: {},
    bindToController: {
      publishTerms: '=',
      balance: '@?',
      agencyBalance: '@?',
      category: '@',
      locationPath: '=',
      latitude: '@?',
      longitude: '@?',
      photosCount: '@?',
      /**
       * Функция вызывается после загрузки/обновления условий размещений
       * @callback onLoadCallback
       * @type {onLoadCallback}
       */
      onLoadComplete: '&?',
      /**
       * Функция вызывается в начале запроса check-service
       * @type {Function}
       */
      onCheckServiceRequestStart: '&',
      /**
       * Функция вызывается в конце запроса check-service
       * Вернется true если успех, false если ошибка
       * Если запрос прерван, данная функция не будет вызвана
       * @type {Function}
       * @return {Boolean}
       */
      onCheckServiceRequestFinish: '&',
      /**
       * Функция вызывается по клику на Пройти идентификацию
       * @type {Function}
       */
      onPassIdentificationClick: '&',
      additionalDataToRequest: '=',
      userId: '<',
      isSubAgentAsString: '@?isSubAgent',
      isSubAgentWithSpendLimitAsString: '@?isSubAgentWithSpendLimit',
      subAgentMoneySource: '@?',
      subAgentCanViewAgencyBalance: '<?',
    },
    controller,
    controllerAs: 'placingTerms',
    replace: true
  }))
  .name;
